import { ExtensionGroupOption } from '../../extension-register/models/extension-group-option.interface';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface ExtensionSuperviseeItemView extends ExtensionOption {
   extensionSuperviseeId: number;
   supervisorExtensionId: number;
}

export interface ExtensionGroupSuperviseeItemView extends ExtensionGroupOption {
   extensionGroupSuperviseeId: number;
   supervisorExtensionId: number;
   superviseeExtensionGroupId: number;
}

export const extensionSuperviseeKeyFields: string[] = [
   'extensionSuperviseeId',
   'supervisorExtensionId',
   'superviseeExtensionId',
];

export const extensionGroupSuperviseeKeyFields: string[] = [
   'extensionGroupSuperviseeId',
   'supervisorExtensionId',
   'superviseeExtensionGroupId',
];
